// extracted by mini-css-extract-plugin
export default {"title":"SubMenuTitleItem_title__DDWpe","icon":"SubMenuTitleItem_icon__CmyQx"};